import { DirectionCta } from "../components/pages/partners/DirectionCta";
import { ProposalCta } from "../components/pages/partners/ProposalCta";
import { StatsBar } from "../components/pages/partners/StatsBar";
import { ProcessSteps } from "../components/pages/partners/ProcessSteps";
import { Layout } from "../components/shared/Layout";

// Page « Partenaire Réseau » : jeu de textes « partners-network » (base i18n).
const BASE = "partners-network";

export function PartenersNetwork(){
    return(
        <Layout>
            <DirectionCta base={BASE} />
            <ProposalCta base={BASE} />
            <StatsBar base={BASE} />
            <ProcessSteps base={BASE} />
        </Layout>
    )
}
